module.exports = __webpack_public_path__ + "static/media/A Thousand Eyes.c054c2ad.jpg";